import {
  any,
  bool,
  func,
  number,
  object,
  oneOf,
  string,
} from 'prop-types';
import {
  Box,
  TextField,
  Typography,
} from '@material-ui/core';

import {
  InputClabe,
  InputCreditCard,
  InputCreditCardExpireTime,
  InputCurrency,
  InputMxPhone,
  InputPercentage,
} from './inputs';

function NumberControl(props) {
  const {
    disabled,
    events = {},
    name,
    onBlur,
    onChange,
    settings: { format },
    size,
  } = props;

  const inputComponent = {
    clabe: InputClabe,
    credit_card: InputCreditCard,
    credit_card_expire_time: InputCreditCardExpireTime,
    currency: InputCurrency,
    mx_phone: InputMxPhone,
    percentage: InputPercentage,
  }[format];

  return (
    <Box sx={{
      mb: props.mb,
    }}>
      <Typography style={{
        fontWeight: 'bold',
        color: disabled ? '#0000004e' : '',
      }} variant="h6"
      gutterBottom>
        {props.label}
      </Typography>
      <TextField
        disabled={disabled}
        error={props.error}
        fullWidth={true}
        helperText={props.helperText}
        InputProps={{
          inputComponent,
          style: {
            borderRadius: props.borderRadius,
            height: '50px',
            border: '#CED8E3',
          },
        }}
        name={name}
        onBlur={onBlur}
        onChange={({ target }) => {
          let { value } = target;
          if (!inputComponent) {
            value = parseFloat(value.replace(/[^\d.-]/g, ''));
            value = Math.max(props.minValue, value);

            if (value > props.maxValue) {
              value = props.maxValue;
            }
          }

          onChange({
            target: {
              name,
              value,
            },
          });

          if (events.onChange) {
            events.onChange({
              name,
              value: value || '',
            });
          }
        }}
        size={size}
        type={inputComponent ? 'text' : 'number'}
        variant={props?.variant ?? 'outlined'}
        value={props.value}
        style={{
          backgroundColor: 'rgba(245, 245, 245, 0.01)',
        }}
      />
    </Box>
  );
}

NumberControl.defaultProps = {
  disabled: false,
  error: false,
  onBlur: () => { },
  onChange: () => { },
  settings: {},
  borderRadius: 17,
  mb: 2,
  maxValue: Infinity,
  minValue: 0,
};

NumberControl.propTypes = {
  disabled: bool,
  error: bool,
  events: object,
  helperText: string,
  label: string,
  name: string,
  onBlur: func,
  onChange: func,
  borderRadius: number,
  settings: {
    format: oneOf([
      'clabe',
      'credit_card',
      'credit_card_expire_time',
      'currency',
      'mx_phone',
      'percentage',
    ]),
  },
  size: oneOf([
    'small',
    'medium',
  ]),
  value: any,
  variant: oneOf([
    'filled',
    'outlined',
  ]),
  mb: number,
  maxValue: number,
  minValue: number,
};

export default NumberControl;
